import { render, staticRenderFns } from "./administerer.vue?vue&type=template&id=7348c1f5&scoped=true"
import script from "./administerer.vue?vue&type=script&lang=js"
export * from "./administerer.vue?vue&type=script&lang=js"
import style0 from "./administerer.vue?vue&type=style&index=0&id=7348c1f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7348c1f5",
  null
  
)

export default component.exports